var map = {
	"./female/body/0_400.png": 135,
	"./male/body/0_400.png": 153
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1554;


//////////////////
// WEBPACK FOOTER
// ./src/layers ^\.\/.*\/body\/0_400\.png$
// module id = 1554
// module chunks = 0